import { jsx as _jsx } from "react/jsx-runtime";
import Profile from "../components/Profile/Profile";
import AppLayout from "./common/AppLayout";
const SettingsContainer = (props) => (_jsx(AppLayout, { children: _jsx(Profile, {}) }));
export default SettingsContainer;
